import { render, staticRenderFns } from "./ContactAttributesAssignValue.vue?vue&type=template&id=5b522a0d&"
import script from "./ContactAttributesAssignValue.vue?vue&type=script&lang=js&"
export * from "./ContactAttributesAssignValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports